module.exports = __webpack_public_path__ + "img/ca.2159b831.png";